import React, { Component } from "react";
import {
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
} from "@material-ui/core/";
import { ExpandMore, ExpandLess } from "@material-ui/icons";
import { Button, Card, CardBody } from "reactstrap";
import Loader from "./../../../../../Global/Loader";
import { withRouter } from "react-router-dom";
import "./../../styles/styles.scss";
import { withNamespaces } from "react-i18next";
import CustomEntities from "../CustomEntities";
import { TemplateOrderService, TemplatePODetail } from "../../../template";
import ListItem from "./components/listItem";
import moment from "moment";
import FormCard from "../Forms";
import { validatePermission } from "./utils/validatePermission";
import { moduleActions } from "../../../../../Global/Permission/constants";
import { Autocomplete, TextField } from "@mui/material";
import Axios from 'axios'
import { es, enUS } from "date-fns/locale";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { openNotification } from "../../../../Components/Notification";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Services } from "../../../../../../repositories/clients/Services";
import createModal from "../../../../Components/ModalV2";

class poSumaryDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...props.formData,
      isMobil: false,
      purchaseOrderexpanded: false,
      data: this.props.formData,
      steps: this.props.steps,
      isEditMode: false,
      purchaseOrderId: this.props.match?.params?.id || -1,
      createFormsData: [],
      generalInfo: [],
      poInfo: {},
      editablePo: {},
      info: this.props.info || {},
      unEditedInfo: {},
      selectCatalog: [],
      tablaClientes: "",
      pickupAddressInput: true,
      deliverAddressInput: true,
      embarqueInfo: [],
      dateOpen: [],
      changeValues: false,
      loadingInfo: true,
      loadingTmpInfo: false,
      panelEmbarque: true,
      detailExpanded: true,
      resumeExpanded: true,
      poItemsExpanded: true,
      entityValidForm: false,
      infoValidForm: false,
      detailValidForm: false,
      modalAccept: false,
      modalReject: false,
      modalConfirmReactivate: false,
      containerColumns: [
        {
          label: this.props.t("contianer_num"),
          key: "ContainerNo",
          minWidth: 310,
          maxWidth: 310,
        },
        {
          label: this.props.t("seal"),
          key: "Seal",
          minWidth: 310,
          maxWidth: 310,
        },
        {
          label: this.props.t("container_type"),
          key: "ContainerType",
          minWidth: 310,
          maxWidth: 310,
        },
      ],
      search: "",
      key: 1,
      valueRejection: null,
      isMessageVisible: false,
      isSubmitting: false,
      disabledRejection: true,
      disabledReactivate: true,
      isModalOpen: false,
      isModalOpenReactivate: false,
      catReject: [
        { label: this.props.t("po_management_detail_cat_reject_op1"), id: 1 },
        { label: this.props.t("po_management_detail_cat_reject_op2"), id: 2 },
        { label: this.props.t("po_management_detail_cat_reject_op3"), id: 3 },
        { label: this.props.t("po_management_detail_cat_reject_op4"), id: 4 },
      ],
      openDate: false,
      formDate: [{
        label: "resume.resumeCollapse.destinationDate",
        format: "DD-MM-YYYY",
        id: "requiredAtDestination",
        placeHolder: "required_at_destination",
        required: true,
        class: "col-6 input-form",
        value: null,
        open: false // Control de apertura para este DatePicker
      },
      {
        label: "resume.shared.uploadRequest",
        format: "DD-MM-YYYY",
        id: "requestedCargoReady",
        placeHolder: "required_at_destination",
        required: true,
        class: "col-6 input-form",
        value: null,
        open: false
      }],
      FIELDS_WITHOUT_QUOTES: new Set([
        "SupplierAddress",
        "SupplierContact",
        "ConsigneeAddress",
        "ConsigneeContact",
        "ProductType",
        "Division",
        "POL",
        "POD",
        "Project",
        "WMSReference",
        "CustomerReference",
        "Buyer",
        "OrderCurrency",
        "NoPallets",
        "PalletsType",
        "Description",
        "SpecialInstructions",
        "PickupAddress",
        "DeliveryAddressPO",
        "OriginZipCode",
        "DestinationZipCode",
        // Item
        "CaseVolume",
        "CaseDescription",
        "VendorCode",
        "HSCode",
        "Invoice",
        "Value",
        "Currency",
        "Size",
      ]),
    };
  }

  componentDidMount = async () => {
    let details = navigator.userAgent;
    let regexp = /android|iphone|kindle|ipad/i;
    let isMobileDevice = regexp.test(details);

    this.setState({
      isMobil: isMobileDevice,
    });

    this.setState({
      loadingInfo: false,
      poInfo: this.props.poInfo || {},
      poInfoBeforeUpdate: this.props.poInfo || {},
    });
  };

  componentDidUpdate(prevProps) {
    if (this.props.poInfo !== prevProps.poInfo) {
      this.setState({
        poInfo: this.props.poInfo || {},
        loadingInfo: false,
      });
    }
  }

  editPurchaseOrder = () => {
    this.setState({ isEditMode: true });
  };
  cancelEdit = () => {
    this.setState({ isEditMode: false });
  };

  hasRequiredValue = (value) => {
    if (value === null || value === undefined) return false;
    if (typeof value === "string") return value.trim().length > 0;
    if (Array.isArray(value)) return value.length > 0;
    return true;
  };

  getMissingEntityFields = (update) => {
    const entityFields = [
      {
        entityId: "SupplierId",
        fieldId: "SupplierAddress",
        fieldLabel: this.props.t("address"),
      },
      {
        entityId: "SupplierId",
        fieldId: "SupplierContact",
        fieldLabel: this.props.t("contact"),
      },
      {
        entityId: "ConsigneeId",
        fieldId: "ConsigneeAddress",
        fieldLabel: this.props.t("address"),
      },
      {
        entityId: "ConsigneeId",
        fieldId: "ConsigneeContact",
        fieldLabel: this.props.t("contact"),
      },
    ];

    return [...new Set(
      entityFields
        .filter(
          ({ entityId, fieldId }) =>
            update[entityId] && !this.hasRequiredValue(update[fieldId])
        )
        .map(({ fieldLabel }) => fieldLabel)
    )];
  };

  getMissingRequiredFields = (update) => {
    const missingFields = [];
    const seenFields = new Set();
    const requiredFields = [
      ...TemplateOrderService.edit,
      ...TemplatePODetail.edit,
    ];

    requiredFields.forEach((field) => {
      if (!field.required || seenFields.has(field.id)) return;

      if (!this.hasRequiredValue(update[field.id])) {
        missingFields.push(this.props.t(field.label));
        seenFields.add(field.id);
      }
    });

    return [...missingFields, ...this.getMissingEntityFields(update)];
  };

  canEditItems = () => {
    const { poInfo } = this.state;
    return this.getMissingRequiredFields(poInfo).length === 0;
  };

  putPurchaseOrder = () => {
    const { poInfo, editablePo, changeValues } = this.state;
    const update = { ...poInfo, ...editablePo };
    let isValid = true;

    const requiredFields = [
      ...TemplateOrderService.edit,
      ...TemplatePODetail.edit
    ];


    for (const field of requiredFields) {
      if (field.required && !update[field.id]) {
        isValid = false;
        break;
      }
    }

    const dependentValidations = [
      {
        id: 'ConsigneeId',
        requiredFields: ['ConsigneeContact', 'ConsigneeAddress']
      },
      {
        id: 'SupplierId',
        requiredFields: ['SupplierContact', 'SupplierAddress']
      },
    ];

    for (const validation of dependentValidations) {
      if (update[validation.id]) {
        for (const depField of validation.requiredFields) {
          if (!update[depField]) {
            isValid = false;
            break;
          }
        }
      }
    }

    if (!isValid) {
      if (changeValues) {
        openNotification('error', this.props.t("add_all_mandatory_fields"));
        this.setState({ changeValues: false });
      }
      return;
    }

    this.setState({ isEditMode: false });
    this.props.actualiza(update);
  };


  handleChange = (event) => {
    const { name, value } = event.target;
    this.props.updateFormData({
      ...this.props.formData,
      [name]: value,
    });
  };

  panelChange = (id) => (evt, expanded) => {
    if (id === "items") {
      this.setState({ poItemsExpanded: expanded });
    } else if (id === "resume") {
      this.setState({ resumeExpanded: expanded });
    } else if (id === "detail") {
      this.setState({ detailExpanded: expanded });
    } else {
      let { createFormsData, generalInfo } = this.state;
      createFormsData.forEach((form) => {
        if (form.id === id) {
          form.expanded = expanded;
        }
      });
      generalInfo.forEach((form) => {
        if (form.id === id) {
          form.expanded = expanded;
        }
      });
      this.setState({ createFormsData });
    }
  };

  updateEntityInfo = (id, value) => {
    let { editablePo } = this.state;
    editablePo[id] = value;
    this.setState({ editablePo, changeValues: true });
  };

  setOrderSearch = (name, value) => {
    this.setState(
      {
        search: value,
        activeInvoicePage: 1,
        numberPageInvoice: 1,
      },
      () => {
        // this.getOrdersList();
      }
    );
  };

  formatDate = (value, format) => {
    if (!format) return value;
    const parsedDate = moment(value, format);
    if (parsedDate.isValid()) {
      return parsedDate.format(format);
    } else {
      return value;
    }
  };

  buildSelect = () => {
    let { catReject, valueRejection } = this.state
    return (
      <div className="col-xs-10 col-sm-10 col-md-12 col-lg-12 align-items-center mr-auto ml-auto mt-3">
        <Autocomplete
          options={catReject}
          getOptionLabel={(option) => option.label}
          renderInput={(params) => (
            <TextField {...params} label={this.props.t("po_management_detail_reject_alert_placeholder")} variant="standard" />
          )}
          value={valueRejection}
          onChange={this.handleChangeDrop}
          style={{ color: "#000a2e", fontFamily: "SF Pro Display" }}
          ListboxProps={{
            sx: {
              fontSize: 12,
              color: "#000a2e",
              fontFamily: "SF Pro Display",
            },
            // style: {
            //   maxHeight: 160, // Aproximadamente 6 opciones visibles
            // },
          }}
          sx={{
            '& .MuiAutocomplete-input, & .MuiInputLabel-root': {
              fontSize: 12,
              color: "#000a2e",
              fontFamily: "SF Pro Display",
            },
            // Estilo para ocultar la flecha (icono de selección)
            '& .MuiAutocomplete-endAdornment': {
              display: 'none'
            },
          }}
          clearOnEscape
          noOptionsText={this.props.t("po_management_select_no_options")}
          componentsProps={{
            popupIndicator: {
              title: '', // Desactivar el tooltip aquí
            }
          }}
        />
      </div>
    )
  }

  handleClose = () => this.setState({ openDate: false });

  Label = ({ value, required, error }) => {

    return (
      <label
        className="label-euro"
        style={{ color: required && error ? "red" : "#000a2e" }}
      >
        {value} {required && <this.RequiredSpan />}
      </label>)
  }

  RequiredSpan = () => <span style={{ color: "#ff0000" }}>*</span>;

  resetFormDate = () => {
    let resetFormDate = this.state.formDate.map(item => ({
      ...item,
      value: null,
    }));

    this.setState({ formDate: resetFormDate, disabledReactivate: true });
  };

  handleChangeDate = (index, newValue) => {
    let formDate = [...this.state.formDate];
    formDate[index].value = newValue;
    formDate[index].open = false;

    const allFieldsFilled = formDate.every(item => item.value);

    this.setState({ formDate, disabledReactivate: !allFieldsFilled });
  };

  handleOpenClose = (index, isOpen) => {
    let formDate = [...this.state.formDate];
    formDate[index].open = isOpen;
    this.setState({ formDate });
  };

  buildDate = () => {
    let { formDate } = this.state;

    let form = formDate.map((item, index) => {
      return (
        <div className={item.class} key={item.id}>
          <div className="d-flex justify-content-start">
            <label>
              {this.props.t(item.label)}{" "}
              {item.required ?
                <span style={{ color: "#ff0000" }}>*</span>
                :
                false
              }
            </label>
          </div>
          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={this.props.lng === "US" ? enUS : es}>
            <DatePicker
              open={item.open}
              onOpen={() => this.handleOpenClose(index, true)}
              onClose={() => this.handleOpenClose(index, false)}
              // label={this.props.t(item.label)}
              value={item.value}
              onChange={(newValue) => this.handleChangeDate(index, newValue)}
              inputProps={{
                placeholder: this.props.lng === "US" ? "mm/dd/yyyy" : 'dd/mm/aaaa',
                readOnly: true
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  onClick={() => this.handleOpenClose(index, true)}
                  InputProps={{
                    ...params.InputProps,
                    classes: {
                      input: "input-euro",
                    },
                    endAdornment: null,
                  }}
                  variant="standard"
                />
              )}
            />
          </LocalizationProvider>
        </div>
      );
    });

    return (
      <div className="mt-3 row">
        {form}
      </div>
    );
  }

  handleChangeDrop = (event, newValue) => {
    this.setState({ valueRejection: newValue, disabledRejection: newValue ? false : true });
  };

  acceptPo = async () => {
    let { purchaseOrderId } = this.state
    let body = { usr: this.props.userid, poId: purchaseOrderId }

    try {
      let url = `${Services.PURCHASE_ORDER.path}purchaseOrder/acceptPo`;
      await Axios.post(url, body);
      await this.props.getPO()
      this.setState({
        key: Math.random()
      })
      this.toggleModals('aceptar')
    } catch (error) {
      console.log("🚀 ~ poSumaryDetail ~ acceptPo= ~ error:", error)
    }
  }

  commentPo = async () => {
    let { purchaseOrderId, valueRejection } = this.state
    let message = `${this.props.t("po_management_detail_reject_reason") + " " + valueRejection.label}`
    let body = { usr: this.props.userid, poId: purchaseOrderId, valueRejection: message }

    try {
      let url = `${Services.PURCHASE_ORDER.path}purchaseOrderComments/rejectCommen`;
      await Axios.post(url, body);
      await this.props.getPO()
      await this.props.getComments()
      this.setState({
        key: Math.random(),
        valueRejection: null,
        isModalOpen: false
      })
    } catch (error) {
      console.log("🚀 ~ poSumaryDetail ~ rejectPo= ~ error:", error)
    }
  }

  rejectPo = async () => {
    let { purchaseOrderId } = this.state
    this.setState({ disabledRejection: true })
    let body = { usr: this.props.userid, poId: purchaseOrderId, lng: this.props.lng, rolId: this.props.rolId }
    try {
      let url = `${Services.PURCHASE_ORDER.path}supplier-management/rejectPo`;
      await Axios.post(url, body);
      this.commentPo()
    } catch (error) {
      console.log("🚀 ~ poSumaryDetail ~ rejectPo= ~ error:", error)
    }
  }

  reactivatePo = async () => {
    let { formDate, purchaseOrderId } = this.state
    this.setState({ disabledReactivate: true })
    let body = {
      requiredAtDestination: formDate[0].value,
      requestedCargoReady: formDate[1].value,
      usr: this.props.userid,
      poId: purchaseOrderId
    }
    try {
      let url = `${Services.PURCHASE_ORDER.path}purchaseOrder/reactivatePo`;
      await Axios.post(url, body);
      await this.props.getPO()
      this.setState({
        key: Math.random(),
        isModalOpenReactivate: false
      })
      this.resetFormDate()

    } catch (error) {
      console.log("🚀 ~ poSumaryDetail ~ reactivatePo= ~ error:", error)
    }
  }

  handleOk = () => {
    this.setState({ isModalOpen: true, modalReject: false });
  };

  handleOkReactivate = () => {
    this.setState({ isModalOpenReactivate: true, modalConfirmReactivate: false });
  };

  handleCancel = () => {
    this.setState({
      modalAccept: false,
      modalReject: false,
      isModalOpen: false,
      modalConfirmReactivate: false,
      valueRejection: null,
      disabledRejection: true,

      isModalOpenReactivate: false
    })

    this.resetFormDate()
  };

  // Buttons que renderizara el modal

  reactivateButtons = [
    {
      text: this.props.t("po_management_detail_reject_alert_button_cancel"),
      onClick: this.handleCancel,
      type: "secondary",
    },
    {
      text: this.props.t("po_management_detail_reject_alert_button_accept"),
      onClick: this.reactivatePo,
      type: "primary",
      disabled: this.disabledReactivate,
    }
  ];


  toggleModals = (action) => {
    let { modalAccept, modalReject, modalConfirmReactivate } = this.state

    if (action == 'aceptar') {
      this.setState({
        modalAccept: !modalAccept
      })
    } else if (action == 'reject') {
      this.setState({
        modalReject: !modalReject
      })
    } else if (action == 'reactivate') {
      this.setState({
        modalConfirmReactivate: !modalConfirmReactivate
      })
    }
  }

  render() {
    const { loadingInfo, poInfo, isMobil, isEditMode, key, isModalOpen, disabledRejection, isModalOpenReactivate, disabledReactivate, modalAccept, modalReject, modalConfirmReactivate, FIELDS_WITHOUT_QUOTES } = this.state;

    if (loadingInfo) {
      return <Loader />;
    }

    return (
      <div className="pt-3">
        {validatePermission(this.props.rolId, moduleActions.SUPPLIER_MANAGEMENT_EDIT) && (isEditMode ? (
          <div className="row col-12">
            <div className="col-6"></div>
            <div
              className="col-6"
              style={{ marginTop: isMobil ? "" : "-70px" }}
            >
              <Button
                color="primary"
                className="float-right custom-width-btn ml-2"
                onClick={() => this.putPurchaseOrder()}
              >
                {this.props.t("update")}
              </Button>
              <Button
                color="secondary"
                className="float-right custom-width-btn"
                onClick={() => {
                  this.cancelEdit();
                }}
              >
                {this.props.t("cancel")}
              </Button>
            </div>
          </div>
        ) : (
          <div className="row">
            <div className="col-xs-12 col-md-6 col-lg-6 btns-header pb-3 ml-auto">
    
              {
                [71].includes(poInfo.StatusIdPo) && ['1', '8', '9'].includes(this.props.rolId) ?
                  <>
                    <Button
                      color="primary"
                      className="float-right custom-width-btn ml-2"
                      onClick={() => this.toggleModals('aceptar')}
                    >
                      {this.props.t("po_management_detail_accept_po")}
                    </Button>
                    <Button
                      color="secondary"
                      className="float-right custom-width-btn"
                      onClick={() => this.toggleModals('reject')}
                    >
                      {this.props.t("po_management_detail_reject_po")}
                    </Button>
                  </>
                  : false
              }
            </div>
          </div>
        ))}
        <div>
          <Card className="myCard">
            <CardBody>
              <div className="row">
                <div className="col-xs-12 col-md-12 col-lg-5 d-flex align-items-center">
                  <div className="col-xs-3 col-md-4 col-lg-3">
                    <span className="custom-number-header">{poInfo.PONumber}</span>
                  </div>
                  <div className="col-xs-5 col-md-4 col-lg-4">
                    <span>{poInfo.POInternalNumber}</span>
                  </div>
                  <div className="col-xs-4 col-md-4 col-lg-5">
                    <span className={poInfo.StatusIdPo !== 71 ? "badge badge-euro m1" : "badge badge-euro-created m-1"}>{poInfo.StatusPo}</span>
                  </div>
                </div>
                <div className="col-xs-12 col-md-12 col-lg-7 row">
                  {
                    poInfo.ReactivationDate ?
                      <div className="col-xs-4 col-md-4 col-lg-4 ml-auto">
                        <div >
                          <em className="label_title bold mr-1">{this.props.t("po_management_detail_reactivation_date")}</em>
                          <span className="label-euro">{poInfo.ReactivationDate}</span>
                        </div>
                        <div>
                          <em className="label_title bold mr-1">{this.props.t("user")}:</em>
                          <span className="label-euro">{poInfo.UserReactivation}</span>
                        </div>
                      </div>
                      : false
                  }
                  {
                    [74].includes(poInfo.StatusIdPo) ?
                      <div className="col-xs-4 col-md-4 col-lg-4 ml-auto">
                        <div >
                          <em className="label_title bold mr-1">{this.props.t("po_management_detail_reject_date")}</em>
                          <span className="label-euro">{poInfo.RejectionDate}</span>
                        </div>
                        <div>
                          <em className="label_title bold mr-1">{this.props.t("user")}:</em>
                          <span className="label-euro">{poInfo.UserRejection}</span>
                        </div>
                      </div> :
                      ![71].includes(poInfo.StatusIdPo) ?
                        <div className="col-xs-4 col-md-4 col-lg-4 ml-auto">
                          <div >
                            <em className="label_title bold mr-1">{this.props.t("po_management_detail_acceptance_date")}</em>
                            <span className="label-euro">{poInfo.AcceptanceDate}</span>
                          </div>
                          <div>
                            <em className="label_title bold mr-1">{this.props.t("user")}:</em>
                            <span className="label-euro">{poInfo.UserAcceptance}</span>
                          </div>
                        </div> : false
                  }
                  {/* </div> */}
                  <div className="col-xs-4 col-md-4 col-lg-4 ml-auto">
                    <div >
                      <em className="label_title bold mr-1">{this.props.t("conclude_update")}:</em>
                      <span className="label-euro">{poInfo.UpdateDate}</span>
                    </div>
                    <div>
                      <em className="label_title bold mr-1">{this.props.t("user")}:</em>
                      <span className="label-euro">{poInfo.UserUpdate}</span>
                    </div>
                  </div>
                </div>
              </div>
            </CardBody>
          </Card>
          <Card className="myCard">
            <CardBody>
              <CustomEntities
                updateEntityInfo={this.updateEntityInfo}
                isEditMode={this.state.isEditMode}
                poInfo={poInfo}
              />
            </CardBody>
          </Card>

          {this.state.generalInfo.map((general) => {
            return (
              <Card className="myCard">
                <ExpansionPanel
                  elevation={0}
                  defaultExpanded
                  onChange={this.panelChange(general.id)}
                >
                  <ExpansionPanelSummary
                    expandIcon={
                      general.expanded ? <ExpandLess /> : <ExpandMore />
                    }
                  >
                    <div
                      style={{ display: "inline-flex", alignItems: "center" }}
                    >
                      <div style={{ marginRight: "27px" }}></div>
                      <h4 className="title-forms">
                        {" "}
                        {this.props.t(general.titulo)}
                      </h4>
                    </div>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>
                    <CardBody>
                      <div
                        className="col-12"
                        style={{ marginTop: "-2em", marginLeft: "-3px" }}
                      >
                        {
                          <div>
                            <div className="row">{general.form}</div>
                          </div>
                        }
                      </div>
                    </CardBody>
                  </ExpansionPanelDetails>
                </ExpansionPanel>
              </Card>
            );
          })}
          <Card className="myCard">
            <ExpansionPanel
              elevation={0}
              defaultExpanded
              onChange={this.panelChange("resume")}
            >
              <ExpansionPanelSummary
                expandIcon={
                  this.state.resumeExpanded ? <ExpandLess /> : <ExpandMore />
                }
              >
                <div style={{ display: "inline-flex", alignItems: "center" }}>
                  <div className="euro-title-form">
                    {this.props.t(TemplateOrderService.titulo)}
                  </div>
                </div>
              </ExpansionPanelSummary>
              <ExpansionPanelDetails>
                <CardBody>
                  <div
                    className="col-12"
                    style={{ marginTop: "-2em", marginLeft: "-3px" }}
                  >
                    <div>
                      <div className="row">
                        <FormCard
                          fields={TemplateOrderService}
                          edit={isEditMode}
                          values={poInfo}
                          updateEntityInfo={this.updateEntityInfo}
                          lang={this.props.lang}
                        />
                      </div>
                    </div>
                  </div>
                </CardBody>
              </ExpansionPanelDetails>
            </ExpansionPanel>
          </Card>
          <Card className="myCard">
            <ExpansionPanel
              elevation={0}
              defaultExpanded
              onChange={this.panelChange("detail")}
            >
              <ExpansionPanelSummary
                expandIcon={
                  this.state.detailExpanded ? <ExpandLess /> : <ExpandMore />
                }
              >
                <div style={{ display: "inline-flex", alignItems: "center" }}>
                  <div className="card-header">
                    <div className="card-title" style={{ fontWeight: "bold" }}>
                      {this.props.t(TemplatePODetail.titulo)}
                    </div>
                  </div>
                </div>
              </ExpansionPanelSummary>
              <ExpansionPanelDetails>
                <CardBody>
                  <div
                    className="col-12"
                    style={{ marginTop: "-2em", marginLeft: "-3px" }}
                  >
                    <div>
                      <div className="row">
                        <FormCard
                          edit={isEditMode}
                          fields={TemplatePODetail}
                          values={poInfo}
                          lang={this.props.lang}
                          updateEntityInfo={this.updateEntityInfo}
                        />
                      </div>
                    </div>
                  </div>
                </CardBody>
              </ExpansionPanelDetails>
            </ExpansionPanel>
          </Card>
          <Card className="myCard">
            <ExpansionPanel
              elevation={0}
              defaultExpanded
              onChange={this.panelChange("items")}
            >
              <ExpansionPanelSummary
                expandIcon={
                  this.state.poItemsExpanded ? <ExpandLess /> : <ExpandMore />
                }
              >
                <div style={{ display: "inline-flex", alignItems: "center" }}>
                  <div className="card-header">
                    <div className="card-title" style={{ fontWeight: "bold" }}>
                      {this.props.t("resume.itemsCollapse.title")}
                    </div>
                  </div>
                </div>
              </ExpansionPanelSummary>
              <ExpansionPanelDetails className="p-0">
                <ListItem
                  poId={this.state.purchaseOrderId}
                  user={this.props.userid}
                  getPO={this.props.getPO}
                  rolId={this.props.rolId}
                  poStatus={poInfo.StatusIdPo}
                  key={key}
                  FIELDS_WITHOUT_QUOTES={FIELDS_WITHOUT_QUOTES}
                  canEditItems={this.canEditItems()}
                />
              </ExpansionPanelDetails>
            </ExpansionPanel>
          </Card>
        </div>
        {createModal({
          isModalOpen: modalAccept,
          component: (
            <>
              <div className="col-12" style={{ textAlign: "center" }}>
                <p>{this.props.t('po_management_detail_confirm_accept_alert')}</p>
                <p className="euro-title-form">{this.state.poInfo.PONumber + '?'}</p>
              </div>
            </>
          ),
          buttons: [
            {
              text: this.props.t("po_management_detail_button_no"),
              onClick: this.handleCancel,
              type: "secondary",
            },
            {
              text: this.props.t("po_management_detail_button_yes"),
              onClick: this.acceptPo,
              type: "primary",
            }
          ],
          onCancel: this.handleCancel
        })}
        {createModal({
          isModalOpen: modalReject,
          component: (
            <>
              <div className="col-12" style={{ textAlign: "center" }}>
                <p>{this.props.t('po_management_detail_reject_alert')}</p>
                <p className="euro-title-form">{this.state.poInfo.PONumber + '?'}</p>
              </div>
            </>
          ),
          buttons: [
            {
              text: this.props.t("po_management_detail_button_no"),
              onClick: this.handleCancel,
              type: "secondary",
            },
            {
              text: this.props.t("po_management_detail_button_yes"),
              onClick: this.handleOk,
              type: "primary",
            }
          ],
          onCancel: this.handleCancel
        })}
        {createModal({
          isModalOpen: isModalOpen,
          titleModal: this.props.t('po_management_detail_confirm_reject_alert'),
          component: this.buildSelect(),
          buttons: [
            {
              text: this.props.t("po_management_detail_reject_alert_button_cancel"),
              onClick: this.handleCancel,
              type: "secondary",
            },
            {
              text: this.props.t("po_management_detail_reject_alert_button_accept"),
              onClick: this.rejectPo,
              type: "primary",
              disabled: disabledRejection
            }
          ],
          onCancel: this.handleCancel
        })}
        {createModal({
          isModalOpen: modalConfirmReactivate,
          component: (
            <>
              <div className="col-12" style={{ textAlign: "center" }}>
                <p>{this.props.t('po_management_detail_reactivate_po_alert')}</p>
                <p className="euro-title-form">{this.state.poInfo.PONumber + '?'}</p>
              </div>
            </>
          ),
          buttons: [
            {
              text: this.props.t("po_management_detail_button_no"),
              onClick: this.handleCancel,
              type: "secondary",
            },
            {
              text: this.props.t("po_management_detail_button_yes"),
              onClick: this.handleOkReactivate,
              type: "primary",
            }
          ],
          onCancel: this.handleCancel
        })}
        {createModal({
          isModalOpen: isModalOpenReactivate,
          titleModal: this.props.t('po_management_detail_reactivate_po_alert_confirm'),
          component: this.buildDate(),
          buttons: [
            {
              text: this.props.t('po_management_detail_reject_alert_button_cancel'),
              onClick: this.handleCancel,
              type: "secondary",
            },
            {
              text: this.props.t('po_management_detail_reject_alert_button_accept'),
              onClick: this.reactivatePo,
              type: "primary",
              disabled: disabledReactivate
            }
          ],
          onCancel: this.handleCancel,
          width: '500px'
        })}
      </div>
    );
  }
}

export default withNamespaces()(withRouter(poSumaryDetail));
